export const DEFAULT_MODAL = 'DEFAULT_MODAL';

export const MODAL_TERMS_AND_CONDITIONS_LOGIN = 'MODAL_TERMS_AND_CONDITIONS_LOGIN';
export const SIGN_OUT_MODAL = 'SIGN_OUT_MODAL';
export const MODAL_SIGN_OUT_DURING_CONSULTATION = 'MODAL_SIGN_OUT_DURING_CONSULTATION';
export const MODAL_END_CONSULTATION = 'MODAL_END_CONSULTATION';
export const MODAL_START_CONSULTATION = 'MODAL_START_CONSULTATION';
export const MODAL_CANCEL_APPOINTMENT = 'MODAL_CANCEL_APPOINTMENT';
export const MODAL_UNABLE_TO_CANCEL_APPOINTMENT = 'MODAL_UNABLE_TO_CANCEL_APPOINTMENT';
export const MODAL_NOTIFICATION_ABOUT_START_CONSULTATION = 'MODAL_NOTIFICATION_ABOUT_START_CONSULTATION';
export const MODAL_NOTIFICATION_ABOUT_MISSED_CONSULTATION = 'MODAL_NOTIFICATION_ABOUT_MISSED_CONSULTATION';
export const MODAL_UPLOAD_META_FAILED = 'MODAL_UPLOAD_META_FAILED';
export const MODAL_RETRY_UPLOAD_META = 'MODAL_RETRY_UPLOAD_META';
export const MODAL_UPDATE_UPLOAD_FILE = 'MODAL_UPDATE_UPLOAD_FILE';
export const MODAL_CONSULTATION_MEDIA_DELETE = 'MODAL_CONSULTATION_MEDIA_DELETE';
export const MODAL_TERMS_AND_CONDITIONS = 'MODAL_TERMS_AND_CONDITIONS';
export const MODAL_EDIT_FILE_NAME = 'MODAL_EDIT_FILE_NAME';
export const MODAL_UPLOAD_EXTENSION_FAILED = 'MODAL_UPLOAD_EXTENSION_FAILED';
export const MODAL_UPLOAD_SIZE_FAILED = 'MODAL_UPLOAD_SIZE_FAILED';
export const MODAL_TERMS_AND_CONDITIONS_APPROVE_DECLINE_MODAL = 'MODAL_TERMS_AND_CONDITIONS_APPROVE_DECLINE_MODAL';
export const MODAL_SIGN_OUT_TO_PROCEED = 'MODAL_SIGN_OUT_TO_PROCEED';
export const MODAL_DISCARD_CREATING_APPOINTMENT = 'MODAL_DISCARD_CREATING_APPOINTMENT';
export const MODAL_OOH_APPOINTMENT = 'MODAL_OOH_APPOINTMENT';
export const MODAL_CANNOT_CREATE_APPOINTMENT = 'MODAL_CANNOT_CREATE_APPOINTMENT';
export const UPLOAD_AVATAR_FAILURE_MODAL = 'UPLOAD_AVATAR_FAILURE_MODAL';
export const UPLOAD_AVATAR_INCORRECT_EXTENSION_MODAL = 'UPLOAD_AVATAR_INCORRECT_EXTENSION_MODAL';
export const UPLOAD_AVATAR_SIZE_EXCEEDED = 'UPLOAD_AVATAR_SIZE_EXCEEDED';
export const MODAL_ACCESSIBILITY_STATEMENT = 'MODAL_ACCESSIBILITY_STATEMENT';
export const EDIT_USER_MODAL = 'EDIT_USER_MODAL';
export const CONFIRM_CANCEL_USER_EDIT_MODAL = 'CONFIRM_CANCEL_USER_EDIT_MODAL';
export const APPOINTMENT_FORWARDING_CONSENT_MODAL = 'APPOINTMENT_FORWARDING_CONSENT_MODAL';
export const CREATE_APPOINTMENT_DISCARD_MODAL = 'CREATE_APPOINTMENT_DISCARD_MODAL';
export const UPDATE_APPOINTMENT_DISCARD_MODAL = 'UPDATE_APPOINTMENT_DISCARD_MODAL';
export const CANNOT_CREATE_OR_UPDATE_APPOINTMENT_MODAL = 'CANNOT_CREATE_OR_UPDATE_APPOINTMENT_MODAL';
export const FETCHED_BY_ANOTHER_PROVIDER_MODAL = 'FETCHED_BY_ANOTHER_PROVIDER_MODAL';
export const CONFIRM_UPDATE_GROUPED_APPOINTMENT_MODAL = 'CONFIRM_UPDATE_GROUPED_APPOINTMENT_MODAL';
